import { render, staticRenderFns } from "./ceshi.vue?vue&type=template&id=46d27dea&scoped=true"
import script from "./ceshi.vue?vue&type=script&lang=js"
export * from "./ceshi.vue?vue&type=script&lang=js"
import style0 from "./ceshi.vue?vue&type=style&index=0&id=46d27dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d27dea",
  null
  
)

export default component.exports